import "./__content.scss"; import "./__parent_page.scss"

